<template>
  <v-flex xs12 sm6 md6 lg3 xl2 px-2 mb-2>
    <v-hover>
      <v-card
        color="cardBackground"
        class="px-4 py-2 mb-2 rounded-3"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 5 : 2}`">
        <router-link class="no-link-style" :to="caseRoute">
        <v-card-title class="pa-0 pb-2 pt-1">
          <v-flex xs12>
            <font-awesome-icon
              class="corner-icon"
              icon="check"
              color="secondary"
              style="float: left; margin-top: 6px; margin-right: 9px;">
            </font-awesome-icon>
            <font-awesome-icon
              :title=assignedTo
              class="corner-icon"
              icon="user-check"
              color="secondary"
              style="float: right; margin-top: 6px; margin-right: 0px;"
              v-if="assignedTo"
              >
            </font-awesome-icon>
            <h3 class="primary--text text-truncate mt-1 mb-1 pb-1 pr-3">{{title}}</h3>
          </v-flex>
          <v-flex xs12 pr-4>
            <h4 class="text-truncate">
              <span class="primary--text body-1 opacity-54 pt-1 pr-1" v-if="scheduleType == 'At' && !isOverdue">Do at</span>
                <span class="primary--text body-1 opacity-54 pt-1 pr-1 " v-if="scheduleType == 'By' && !isOverdue">Do by</span>
                <span class="primary--text body-1 opacity-54 pt-1" v-if="!scheduleType">Not scheduled</span>
                <span class="primary--text body-1 breach pt-1 state--text" v-if="isOverdue">Overdue by {{overdueTime}}</span>
              <span
                v-if="!isOverdue"
                class="font-weight-bold primary--text body-1 opacity-54 pt-1">
                {{formattedDate}}
              </span>
            </h4>
          </v-flex>
          <v-flex xs12 pr-4>
          <h4 class="icon-bold-link small">
            <span
              style="font-weight:500; line-height:1.2em"
              class="body-1 mt-2 pt-1 d-block mb-0 primary-text state--text"
            >
            {{caseTitle}}
            </span>
          </h4>
          </v-flex>
        </v-card-title>
        </router-link>
        <v-card-actions class="card-vert-menu">
          <v-menu
            v-if="actionType"
            left offset-y nudge-top="30px"
            origin="center center" transition="scale-transition">
            <v-btn
              flat icon dark small
              slot="activator" class="ma-0 mr-0 pa-0" color="secondary"
              style="margin-top:-3px !important; margin-left:-10px !important;"
              @click.prevent>
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile @click="markAsComplete()" v-if="actionType == 'ManualTask'" >
                <v-icon class="mr-2" color="secondary">check_circle</v-icon>Mark as complete
              </v-list-tile>
                <v-list-tile v-if="actionType == 'AutomaticTask'" @click="dialogRunTask = !dialogRunTask">
                <v-icon class="mr-2" color="secondary">play_circle_filled</v-icon>Run task
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-card-actions>
        <CaseTaskRunDialog :task="task" :dialogRunTask="dialogRunTask"></CaseTaskRunDialog>
        <v-flex v-if="isOverdue" class="severity-border error"></v-flex>
      </v-card>
    </v-hover>
  </v-flex>
</template>

<script>
import { mapState } from "vuex"
import Helpers from "@/helpers.js"
import CaseTaskRunDialog from "@/components/cases/case-edit/CaseTaskRunDialog"

export default {
  name: "assigned-tasks",
  components: { CaseTaskRunDialog },
  data: () => ({
    dialogRunTask: false
  }),
  props: ["task"],
  computed: {
    ...mapState({
      timePref: state => state.currentUser.me.preferences.dateTimeFormat
    }),
    assignedTo() {
      if (this.task.assignedToUser) {
        return `Assigned to ${this.task.assignedToUser.displayName}`
      }
      return undefined
    },
    title() { if (this.task) { return this.task.name } else { return undefined } },
    caseTitle() { if (this.task.case) { return this.task.case.title } else { return undefined } },
    caseRoute() { if (this.task.case) { return { name: 'Case', params: { case_id: this.task.case.id } } } else { return "/" } },
    isAutomated() { return this.task.task && this.task.task.actionType && this.task.task.actionType !== "ManualTask" },
    isOverdue() { if (this.task && this.task.scheduledTime) { return (new Date(this.task.scheduledTime) < new Date()) } else { return false } },
    scheduleType() { if (this.task.scheduledType) { return this.task.scheduledType } else { return undefined } },
    actionType() { if (this.task.actionType) { return this.task.actionType } else { return undefined } },
    overdueTime() { if (this.task.scheduledTime) { return Helpers.calculateTimeDifferenceFromNow(this.task.scheduledTime) } else { return undefined } },
    dueTime() { if (this.task.scheduledTime) { return Helpers.calculateTimeDifferenceFromNow(this.task.scheduledTime) } else { return undefined } },
    formattedDate() {
      if (this.task.scheduledTime) {
        const result = Helpers.formatDate(this.task.scheduledTime, 'h:mma, Do MMM')
        return result
      } else { return undefined }
    }
  },
  methods: {
    markAsComplete() {
      this.$store.dispatch("executeTask", this.task)
    }
  }
}
</script>
<style>
  .severity-border {
    position:absolute;
    width:4px;
    height:100%;
    top:0;
    left:0;
    -webkit-border-top-left-radius: 3px;
    -webkit-border-bottom-left-radius: 3px;
    -moz-border-radius-topleft: 3px;
    -moz-border-radius-bottomleft: 3px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  .severity-border.error, .severity-border.error-notification,  .severity-border.breach {
    background: rgb(219,68,77);
    background: -moz-linear-gradient(top, rgba(219,68,77,1) 0%, rgba(175,31,46,1) 100%) !important;
    background: -webkit-linear-gradient(top, rgba(219,68,77,1) 0%,rgba(175,31,46,1) 100%);
    background: linear-gradient(to bottom, rgba(219,68,77,1) 0%,rgba(175,31,46,1) 100%);
  }

   .severity-border.jeopardy, .severity-border.tertiary-notification {
    background: rgb(233,169,22); /* Old browsers */
    background: -moz-linear-gradient(top, rgba(233,169,22,1) 0%, rgba(219,120,0,1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(233,169,22,1) 0%,rgba(219,120,0,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(233,169,22,1) 0%,rgba(219,120,0,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  }

</style>
